enum TrialEndActions {
  ActivateSubscription = 'activateSubscription',
  CancelSubscription = 'cancelSubscription',
};

export default TrialEndActions;
